export default __webpack_public_path__ + "static/media/wordpress-negative.e904c014.svg";